import { Component, inject, input } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { HelpArticlesDirective } from '@core/help-articles-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rt-infobox-mailbox-trial-provider-sync',
  templateUrl: './infobox-mailbox-trial-provider-sync.component.html',
  styleUrls: ['./infobox-mailbox-trial-provider-sync.component.less'],
  imports: [InfoboxComponent, TranslatePipe, HelpArticlesDirective],
})
export class InfoboxMailboxTrialProviderSyncComponent {
  protected readonly i18n = inject(I18nService);
  protected readonly externalMailboxConnected = input.required<boolean>();
}
